import React from "react";

import { cn } from "lib/utils";
import { Card } from "components/ui/card";

interface Props {
    id?: string;
    title: React.ReactNode;
    titleSize?: "base" | "xl";
    className?: string;
    children: React.ReactNode;
}

export const ProviderDetailCard: React.FC<Props> = ({
    id,
    title,
    titleSize = "base",
    className,
    children,
}) => (
    <Card id={id} variant="detail" className={cn("scroll-mt-6 p-6", className)}>
        <h2
            className={cn(
                "mb-4 font-bold text-foreground",
                titleSize === "xl" ? "text-xl" : "text-base",
            )}
        >
            {title}
        </h2>
        {children}
    </Card>
);
